module.exports = __webpack_public_path__ + "media/reskin-images/img--podcast-listening-837c6c95.png";